import { RevealItem, ScrollReveal } from '#/components/common/ScrollReveal'
import headerIcon from '#/assets/header-icon.svg'
import type { Course } from '#/features/courses/types/course.types'

interface CourseWhatYouLearnOldProps {
  course?: Course
}

export default function CourseWhatYouLearnOld({
  course,
}: CourseWhatYouLearnOldProps) {
  const modules = course?.whatYouLearn || []

  if (modules.length === 0) {
    return null
  }

  return (
    <section
      className="relative w-full pb-20 pt-20 overflow-hidden"
      id="what-you-learn"
    >
      <div
        className="pointer-events-none absolute inset-0 -z-10"
        style={{
          background:
            'radial-gradient(60% 50% at 80% 20%, rgba(255,182,6,0.05) 0%, transparent 70%), radial-gradient(50% 60% at 10% 80%, rgba(0,77,64,0.07) 0%, transparent 70%)',
        }}
      />

      <div className="container mx-auto flex flex-col items-center gap-14">
        {/* Header */}
        <ScrollReveal className="flex flex-col items-center justify-center gap-4 text-center">
          <RevealItem>
            <img alt="" src={headerIcon} />
          </RevealItem>
          <RevealItem>
            <h3 className="text-xl font-bold leading-normal text-primary-900 text-center">
              CURRICULUM MODULES
            </h3>
          </RevealItem>
          <RevealItem className="w-full">
            <h2 className="text-center text-5xl font-bold leading-normal text-neutral-900 max-md:text-4xl max-sm:text-3xl">
              What You Will Learn
            </h2>
          </RevealItem>
        </ScrollReveal>

        {/* Modules grid */}
        <ScrollReveal
          className="grid w-full grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-4"
          stagger={0.1}
        >
          {modules.map((module, idx) => (
            <RevealItem key={module.id || module.title}>
              <div className="group relative flex flex-col gap-5 rounded-[16px] bg-white p-7 shadow-[0px_4px_20px_0px_rgba(106,155,145,0.16)] transition-all duration-300 hover:shadow-[0px_8px_30px_0px_rgba(106,155,145,0.25)] hover:-translate-y-1 h-full border border-neutral-100/60">
                <div className="flex size-14 font-medium items-center justify-center rounded-2xl bg-secondary-500/10 text-2xl text-secondary-500 ring-1 ring-secondary-500/20 transition-colors duration-300 group-hover:bg-secondary-500 group-hover:text-white">
                  {String(idx + 1).padStart(2, '0')}
                </div>

                <div className="flex flex-col gap-2">
                  <h3 className="text-[20px] font-bold leading-normal text-neutral-900">
                    {module.title}
                  </h3>
                  <p className="text-[14px] font-normal leading-relaxed text-neutral-500">
                    {module.description}
                  </p>
                </div>

                <div className="mt-auto h-0.5 w-16 rounded-full bg-linear-to-r from-primary-400 to-primary-200 opacity-0 transition-all duration-300 group-hover:w-full group-hover:opacity-100" />
              </div>
            </RevealItem>
          ))}
        </ScrollReveal>
      </div>
    </section>
  )
}
